module.exports = __webpack_public_path__ + "static/tusas4-2a037d0176de9e61c22fcd6c50e00f28.png";